export function formatUserSummaryLabel(user: App.UserSummary | undefined, fallbackId: string) {
  if (!fallbackId) {
    return '-';
  }

  if (!user?.full_name) {
    return fallbackId;
  }

  return user.email ? `${user.full_name} (${user.email})` : user.full_name;
}
